module.exports = "<div class=\"table-wrapper\">\r\n   <div ng-transclude=\"header\"\r\n        ng-if=\"$ctrl.isHeader\"\r\n        class=\"md-table-header-container\"></div>\r\n   <div ng-transclude=\"actions\"></div>\r\n   <div ng-transclude=\"table\"\r\n        class=\"md-table-container\"></div>\r\n   <div ng-transclude=\"footer\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/lsp-grid/lsp-grid.html
// module id = 1849
// module chunks = 0